module.exports = __webpack_public_path__ + "fonts/Lexend-Bold.95ac37d.woff2";